import { DataQualityHeader } from "@/types/dataQuality/dataQualityTable";
export const headers: DataQualityHeader[] = [
  {
    text: "Vessel",
    type: "string",
    value: "vesselName",
    align: "left",
  },
  {
    text: "Data Availability",
    type: "dataIndicator",
    value: "dataAvailability",
    align: "left",
    tooltip: "Indicates whether critical data tags are available",
    width: "200px",
  },
  {
    text: "Data Outliers",
    type: "dataIndicator",
    value: "dataOutliers",
    align: "left",
    tooltip: "Indicates the amount of outliers for critical data tags",
    width: "200px",
  },
  {
    text: "Speed Log",
    type: "dataIndicator",
    value: "speedLog",
    align: "left",
    tooltip: "Indicates quality of speed log data using drift algorithm that compares it to derived STW",
    width: "200px",
  },
  {
    text: "Noon Report Alignment",
    type: "dataIndicator",
    value: "noonReportAlignment",
    align: "left",
    tooltip: "Indicates the alignment between high frequency sensor data and noon report data. Shows the worst alignment score among Speed Through Water, Shaft Power, and ME Total Eq FO Mass Flow",
    width: "200px",
  },
];
